/************************************************************************************************************
Author                          : Trizent Technologies Private Limited
Date                            : 
Notes/Remarks                   : 

Organization:  	Trizent Technologies Private Limited.
		Module No. 17, SBC, Thejaswini Building
		Phase 1, Technopark, Thiruvananthapuram - 695581, 
		Kerala, India
 
Copyright 2026 (C) Trizent Technologies Pvt Ltd. (www.trizentinc.com)
All rights reserved.
***************************************************************************************************************/

export const columns: TableColumn[] = [
    {
        Header: "tableCommon.sl_no",
        accessor: "slno",
    },
    {
        Header: "downloadPdfScreen.reportName",
        accessor: "document_name",
    },
    {
        Header: "Generated By",
        accessor: "generated_user_name",
    },
    {
        Header: "downloadPdfScreen.generated_datetime",
        accessor: "generated_date_time",
    },
    {
        Header: "QA Status",
        accessor: "file_status",
    },
    
    
  ];


    
  interface TableColumn {
    Header: string;
    accessor: string;
  }